/* Parker Pitt floating modal: video + article. No dependencies.
   Triggers (any element; <a> keeps a real href for crawlers/no-JS):
     data-pp-video="youtube:ID" | "vimeo:ID" | "file:https://.../clip.mp4" (or "file:URL@1080, URL@720"; highest wins)   data-title="..."
     data-pp-article="/pages/slug"   (fetches the page, shows its [data-article] node)
*/
(function(){
  var root=document.getElementById('pp-modal'); if(!root) return;
  var panel=root.querySelector('.ppm-panel'), body=root.querySelector('.ppm-body'),
      title=root.querySelector('.ppm-title'), closeBtn=root.querySelector('.ppm-x'),
      lastFocus=null, cache={};
  var FOCUSABLE='a[href],button:not([disabled]),iframe,video,input,textarea,select,[tabindex]:not([tabindex="-1"])';

  function open(kind, label){
    lastFocus=document.activeElement;
    root.className='ppm is-open ppm--'+kind;
    title.textContent=label||'';
    root.removeAttribute('hidden'); root.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('ppm-lock');
    setTimeout(function(){ closeBtn.focus(); },20);
  }
  function close(){
    if(root.hasAttribute('hidden')) return;
    var v=body.querySelector('video'); if(v){ try{v.pause();}catch(e){} }
    if(player){ try{player.destroy();}catch(e){} player=null; }
    body.innerHTML='';                      /* removing iframe stops YouTube/Vimeo playback */
    root.setAttribute('hidden',''); root.setAttribute('aria-hidden','true');
    root.className='ppm';
    document.documentElement.classList.remove('ppm-lock');
    if(location.hash==='#'+root.dataset.hash){ history.replaceState(null,'',location.pathname+location.search); }
    if(lastFocus&&lastFocus.focus) lastFocus.focus();
  }
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  /* ---- Video defaults: captions OFF, HD (1080p) requested ---- */
  var YT_PARAMS='autoplay=1&rel=0&modestbranding=1&playsinline=1&cc_load_policy=0&iv_load_policy=3&vq=hd1080&hd=1&enablejsapi=1';
  var VIMEO_PARAMS='autoplay=1&dnt=1&quality=1080p&texttrack=false';
  var ytQueue=[], ytLoading=false, player=null;
  function withYT(cb){
    if(window.YT&&window.YT.Player){ cb(); return; }
    ytQueue.push(cb); if(ytLoading) return; ytLoading=true;
    var prev=window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady=function(){ if(typeof prev==='function'){try{prev();}catch(e){}} var q=ytQueue; ytQueue=[]; q.forEach(function(f){f();}); };
    var t=document.createElement('script'); t.src='https://www.youtube.com/iframe_api'; t.async=true; document.head.appendChild(t);
  }
  function ytDefaults(p){
    try{ if(p.setPlaybackQualityRange) p.setPlaybackQualityRange('hd1080','hd1080'); }catch(e){}
    try{ if(p.setPlaybackQuality) p.setPlaybackQuality('hd1080'); }catch(e){}
    try{ p.setOption('captions','track',{}); }catch(e){}
    try{ p.unloadModule('captions'); }catch(e){}
    try{ p.unloadModule('cc'); }catch(e){}
  }
  function attachYT(iframe){
    withYT(function(){
      if(!iframe.isConnected) return;
      player=new window.YT.Player(iframe,{events:{
        onReady:function(e){ ytDefaults(e.target); },
        onApiChange:function(e){ ytDefaults(e.target); },      /* captions module loads late */
        onStateChange:function(e){ if((e.data===1||e.data===3)&&(e.target.__ppHD=(e.target.__ppHD||0)+1)<=6){ ytDefaults(e.target); } }
      }});
    });
  }
  /* file: spec = one URL, or several "URL@1080, URL@720" — the highest resolution wins */
  function bestSource(list){
    var best=null,bh=-1;
    list.split(/\s*,\s*(?=\S+@\d+|https?:|\/)/).forEach(function(x){
      var m=x.match(/^(.*?)(?:@(\d+))?$/), h=m[2]?+m[2]:0;
      if(m[1]&&h>bh){ bh=h; best=m[1]; }
    });
    return best||list;
  }
  function playVideo(spec,label,poster){
    var i=spec.indexOf(':'), type=spec.slice(0,i), id=spec.slice(i+1), html, t=esc(label||'Video');
    if(type==='youtube') html='<iframe width="1920" height="1080" src="https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?'+YT_PARAMS+'&origin='+encodeURIComponent(location.origin)+'" title="'+t+'" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    else if(type==='vimeo') html='<iframe src="https://player.vimeo.com/video/'+encodeURIComponent(id)+'?'+VIMEO_PARAMS+'" title="'+t+'" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    else html='<video src="'+esc(bestSource(id))+'"'+(poster?' poster="'+esc(poster)+'"':'')+' width="1920" height="1080" controls autoplay playsinline preload="metadata"></video>';   /* no <track>: captions off */
    body.innerHTML='<div class="ppm-video">'+html+'</div>';
    var f=body.querySelector('iframe'), v=body.querySelector('video');
    if(type==='youtube'&&f) attachYT(f);
    if(v){ var off=function(){ for(var k=0;k<v.textTracks.length;k++) v.textTracks[k].mode='disabled'; }; off(); v.addEventListener('loadedmetadata',off); if(v.textTracks.addEventListener) v.textTracks.addEventListener('addtrack',off); }
    open('video',label);
  }
  function showArticle(url,label){
    open('article',label);
    body.innerHTML='<p class="ppm-loading">Loading…</p>';
    var done=function(html){
      body.innerHTML=html+'<p class="ppm-perma"><a href="'+esc(url)+'">Open as a page</a></p>';
      body.scrollTop=0; wire(body);
      var h=body.querySelector('h1'); if(h) title.textContent=h.textContent;
    };
    if(cache[url]) return done(cache[url]);
    fetch(url,{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(t){
      var d=new DOMParser().parseFromString(t,'text/html'), a=d.querySelector('[data-article]');
      if(!a) throw 0; cache[url]=a.innerHTML; done(cache[url]);
    }).catch(function(){ window.location.href=url; });
  }
  function wire(scope){
    scope.querySelectorAll('[data-pp-video],[data-pp-article]').forEach(function(el){
      if(el.__pp) return; el.__pp=1;
      if(!el.matches('a,button')){ el.setAttribute('role','button'); el.setAttribute('tabindex','0'); }
      var go=function(e){
        if(e.metaKey||e.ctrlKey||e.shiftKey) return;   /* let new-tab clicks through */
        e.preventDefault();
        var label=el.getAttribute('data-title')||el.getAttribute('aria-label')||'';
        if(el.dataset.ppVideo) playVideo(el.dataset.ppVideo,label,el.getAttribute('data-pp-poster')); else showArticle(el.dataset.ppArticle,label);
      };
      el.addEventListener('click',go);
      el.addEventListener('keydown',function(e){ if((e.key==='Enter'&&!el.matches('a,button'))||(e.key===' '&&!el.matches('a'))) go(e); });
    });
  }
  closeBtn.addEventListener('click',close);
  root.addEventListener('mousedown',function(e){ if(e.target===root||e.target.classList.contains('ppm-backdrop')) close(); });
  document.addEventListener('keydown',function(e){
    if(root.hasAttribute('hidden')) return;
    if(e.key==='Escape'){ e.preventDefault(); close(); return; }
    if(e.key==='Tab'){
      var f=[].filter.call(panel.querySelectorAll(FOCUSABLE),function(n){return n.offsetParent!==null||n===closeBtn;});
      if(!f.length) return; var first=f[0], last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey&&document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
  });
  wire(document);
  window.PPModal={video:playVideo,article:showArticle,close:close};
})();
